import { render, staticRenderFns } from "./Backend.vue?vue&type=template&id=26e4a0c9&scoped=true&"
import script from "./Backend.vue?vue&type=script&lang=ts&"
export * from "./Backend.vue?vue&type=script&lang=ts&"
import style0 from "./Backend.vue?vue&type=style&index=0&id=26e4a0c9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e4a0c9",
  null
  
)

export default component.exports